export const stringConverter = (str) => {

    const string = str.split('_').join(' ');
    return string.charAt(0) + string.slice(1).toLowerCase()

};
  